<template>
  <div>
    <CRow>
      <CCol md="12">
        <CForm>

          <CCard>
            <CCardHeader class="p-1">
              <CRow>
                <CCol col="8" style="text-align: start ;padding:10px 20px 0 20px ">

                  <strong v-if="status_form==0">{{ $t('components.addVisitorTarget') }}</strong>

                </CCol>
                <CCol col="4" style="text-align: end">


                  <CButton v-if="status_form==0" class="mr-1 ml-1"  @click="insert_data_factor()" size="sm"
                           color="secondary">
                    {{ $t('buttons.submit') }}
                  </CButton>

                </CCol>
              </CRow>
            </CCardHeader>

            <CCardBody>


              <CRow>
                <CCol col="3">
                  <CInput
                          v-model="title_target"
                          horizontal
                          :label="$t('targetName')"
                  />
                </CCol>
                <CCol col="3">

                  <CRow form class="form-group">
                    <CCol tag="label" sm="3" class="col-form-label">
                      {{$t('tables.visitor')}}
                    </CCol>
                    <CCol sm="8">
                      <treeselect
                              :label="$t('tables.visitor')"
                              v-model="document_person"
                              :async="true"
                              :load-options="load_persons"
                              :placeholder="$t('tables.visitor')"
                              :normalizer="normalizer_persons"
                      />
                    </CCol>

                  </CRow>
                </CCol>
                <CCol col="3">
                  <CSelect
                          :label="$t('saleTarget')"
                          horizontal
                          :value.sync="selected_target_type"
                          :options="targer_types"
                  />
                </CCol>

                <CCol col="3" >
                  <CInput v-if="selected_target_type==64"
                          v-model="price_target"
                          horizontal
                          :label="$t('tables.amount') "
                  />
                </CCol>

              </CRow>
<hr>
              <CRow v-if="selected_target_type==65">
                <CCol >
                      <treeselect
                              v-model="selected_product"
                              @select="select_product"
                              :async="true"
                              :load-options="load_products"
                              :placeholder="$t('components.searchProduct')"
                              :normalizer="normalizer_products"
                      />
                </CCol>
                <CCol>

                  <CInput
                      :placeholder="$t('components.productQty')"
                      type="number"
                      v-on:keypress="isNumber($event)"
                      v-model="product_count"
                  />
                </CCol>
<!--                <CCol >-->
<!--                  <CSelect-->
<!--                      :placeholder="$t('locationType')"-->
<!--                      type="number"-->
<!--                      v-on:keypress="isNumber($event)"-->
<!--                      :value.sync="selected_target_location"-->
<!--                      :options="targer_locations"-->
<!--                  />-->
<!--                </CCol>-->
<!--                <CCol>-->

<!--                  <CInput-->
<!--                      :placeholder="$t('components.area')"-->
<!--                      v-model="product_district"-->
<!--                  />-->
<!--                </CCol>-->
                <CCol col="1">

                  <CButton v-if="status_form==0" @click="add_product_to_document()" size="sm"
                           color="dark">
                    <CIcon name="cil-plus" size="sm"  />
                  </CButton>
                </CCol>
              </CRow>





              <CDataTable v-if="selected_target_type==65"
                  :items="product_items"
                  :fields="product_fields"

                  :items-per-page="200"
                  hover
                  sorter
                  pagination
              >
                <template #row="{item}">

                  <td style="text-align: center">

                  <p >{{ item.row_id + 1 }}</p>

                  </td>

                </template>
                <template #name="{item}">

                  <td>
                    <p >{{ item.name }}</p>

                  </td>

                </template>


                <template #qty="{item}">

                  <td>
                    <p >{{ item.count }}</p>

                  </td>

                </template>

                <template #summary="{item}">

                  <td>
                    <p >{{ item.summary }}</p>

                  </td>

                </template>


                <template #operation="{item}">
                  <td>
<!--                    <CButton-->
<!--                        color="primary"-->
<!--                        variant="outline"-->
<!--                        square-->
<!--                        size="sm"-->
<!--                        @click="edit_item(item)"-->
<!--                    >{{ $t('buttons.edit') }}-->
<!--                    </CButton>-->
                    <CButton
                        square
                        size="sm"
                        @click="delete_item_dialog(item)"
                    ><CIcon name="cilTrash" class="text-danger" size="sm" />
                    </CButton>
                  </td>
                </template>


              </CDataTable>


            </CCardBody>

          </CCard>
        </CForm>

      </CCol>
    </CRow>
    <CRow>

    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import Vue from "vue";

import {ASYNC_SEARCH} from '@riophae/vue-treeselect'

var simulateAsync=null
    const simulateAsyncOperation = fn => {
        if(simulateAsync!=null){
            clearTimeout(simulateAsync)
        }
        simulateAsync =  setTimeout(fn, 1000)
    }

var product_items = [];


export default {
  name: 'Login',
  components: {
    Treeselect,

  },
  data() {
    return {
      confirm_delete_name:"confirm"+new Date().getTime()+"_"+this.$vnode.tag,

      VUE_APP_Currency: localStorage.getItem('currency'),

      date: '',
      product_items: product_items.map((item, row_id) => {
        return {...item, row_id}
      }),
      product_fields: [
        {key: 'row', label: this.$t('tables.row'),sorter:false, _style: 'width:3%'},
        {key: 'name', label: this.$t('tables.name'), _style: 'width:15%'},
        // {key: 'unit', label: this.$t('tables.unit'), _style: 'width:10%'},
        {key: 'qty', label: this.$t('tables.qty'), _style: 'width:5%;'},
        // {key: 'price', label: this.$t('tables.price'), _style: 'width:10%;'},
        // {key: 'locationType', label: this.$t('locationType'), _style: 'width:10%;'},
        // {key: 'location', label: this.$t('location'), _style: 'width:10%;'},
        {key: 'operation', label: this.$t('tables.operation'), _style: 'width:10%;'},

      ],
      price_target:'',
      selected_target_type:0,

      selected_target_location:this.$t('Region'),
      targer_locations: [
        {
          value:  this.$t('Region'),
          label: this.$t('Region')
        },

        {
          value: this.$t('Town'),
          label: this.$t('Town')
        },
        {
          value: this.$t('components.district'),
          label: this.$t('components.district')
        },{
          value: this.$t('tables.area'),
          label: this.$t('tables.area')
        },

      ],
      selectedType: 1,

      document_person: null,
      document_summary: '',
      title_target: '',


      product_name: '',
      product_count: '',
      product_unit: '',
      product_summary: '',
      product_price: '',
      product_district: '',
      product_off: 0,
      product_tax: 0,

      targer_types: [],

      total_price: 0,
      details: [],
      permission_group_items: [],
      selected_permission_group: 0,

      places_items: [],
      unit_items: [],
      unit_items_filtered: [],
      selected_place: 0,
      selected_product: null,

      status_form: 0,
      master_id: 0,
      load_products({action, searchQuery, callback}) {
        var self = this;

        if (action === ASYNC_SEARCH) {
          simulateAsyncOperation(() => {
            let options;
            const formData = new FormData();

            formData.append('SearchTxt', searchQuery);

            axios.post('GetProducts', formData, {show_pros: true}).then(function (response) {
              options = response.data.data;

              callback(null, options);

              // localStorage.setItem("api_token", response.data.access_token);
              // self.$router.push({ path: 'notes' });
            })
                .catch(function (error) {

                  console.log(error);
                });


            //  const options = this.get_keywords(searchQuery);
            // const options = [1, 2, 3, 4, 5].map(i => ({
            //     id: `${searchQuery}-${i}`,
            //     name: `${searchQuery}-${i}`,
            // }))

          })
        }
      },
      normalizer_products(node) {
        return {
          id: node.id,
          label: node.productCodeName,
        }
      },

      load_persons({action, searchQuery, callback}) {
        var self = this;

        if (action === ASYNC_SEARCH) {
          simulateAsyncOperation(() => {
            let options;
            const formData = new FormData();

            formData.append('SearchTxt', searchQuery);

            axios.post('GetUsers', formData, {show_pros: true}).then(function (response) {
              options = response.data.data;

              callback(null, options);

              // localStorage.setItem("api_token", response.data.access_token);
              // self.$router.push({ path: 'notes' });
            })
                .catch(function (error) {

                  console.log(error);
                });


            //  const options = this.get_keywords(searchQuery);
            // const options = [1, 2, 3, 4, 5].map(i => ({
            //     id: `${searchQuery}-${i}`,
            //     name: `${searchQuery}-${i}`,
            // }))

          })
        }
      },
      normalizer_persons(node) {
        return {
          id: node.userId,
          label: node.personCode +" "+ node.userName +" "+ node.surName+" "+ node.mobileNo,
        }
      },

    }
  }, mounted() {
    this.$root.root_validate_errors = [];

    this.get_sys();
    this.get_places();
    this.get_product_units();
    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
    bus.$on('update_price', (data) => {
      // alert(data);
      if (data == "true") {
        this.$router.push({path: "/dashboard/products/edit-price/" + this.added_product});

      } else {
        this.status_form = 0;
      }
    });

    if (this.$route.params.user_id != null) {
      this.status_form = this.$route.params.user_id;
      this.get_user_data();
    }

    if (this.$route.params.edit_doc_id != null) {
      this.status_form = this.$route.params.edit_doc_id;
      this.get_document_master();
      this.get_document_details();
    }
  }, watch: {
    'selectedType': function () {

    },

    'product_items': function () {
      this.total_price = 0;
      // var off = 0;
      // var tax = 0;
      // this.product_items.forEach((val) => {
      //   this.total_price += (val.count * val.price * val.unit_value);
      //
      // });
      // off = this.product_off;
      // tax = this.product_tax;
      // var off_price = (this.total_price * off) / 100;
      // var tax_price = (this.total_price * tax) / 100;
      // this.total_price = this.total_price - off_price - tax_price;
      // this.total_price = this.total_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

  },
  methods: {
    select_product(node,instance){
      console.log("node is",node)
      this.product_name = node.productName;
      this.product_existance = node.existence;
      this.product_price = node.salePrice;
      this.product_weight = node.weight;
      this.product_off = node.takhfif;
      this.product_tax = node.vat;
      this.product_off_is_percent = node.isPercent;
      this.product_unit = node.productUnitId;
      this.product_unit_name = node.productUnitName;
      this.product_unit_value = 1;

    },
    get_sys() {
      var self = this;

      const formData = new FormData();

      axios.post('GetSysPersonGlobals', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        self.targer_types = [];


        content_data.forEach((val) => {
          var obj = {label: val.title, value: val.id}

          if (val.titleType == 20) {
            self.targer_types.push(obj);
          }

        });
self.selected_target_type = self.targer_types[0].value

      })
          .catch(function (error) {

            console.log(error);
          });

    },


    validateForm: function () {
      this.$root.root_validate_errors = [];


      if ( this.document_person != null && this.title_target != null && this.title_target != "") {
        return true;


      }

      if (this.title_target == '') {
        this.$root.root_validate_errors.push(this.$t('insertTargetName'));
      }

      if (this.document_person == null) {
        this.$root.root_validate_errors.push(this.$t('selectUser'));
      }

      return false;
      // e.preventDefault();
    },
    validateProduct: function () {
      this.$root.root_validate_errors = [];
      var duplicate_product = false;
      this.product_items.forEach((val) => {
        if (val.product_id == this.selected_product) {
          this.$root.root_validate_errors.push(this.$t('dialogs.duplicateProduct'));
          duplicate_product = true;

        }
        // val.row_id = row_index;
        // row_index += 1;
      });

      if (this.product_name != '' && this.product_count != '' && this.product_count != 0 && !duplicate_product) {
        return true;
      }

      if (this.product_name == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertName'));
      }
      if (this.product_count == '' || this.product_count == 0) {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertProductQty'));
      }

      return false;
      // e.preventDefault();
    },
    get_style(color) {
      return {
        myStyle: {
          backgroundColor: color
        }
      }
    },
    add_product_to_document() {
      if (this.validateProduct()) {

        var product_new_item = [];
        this.unit_items.forEach((val) => {
          if (val.id == this.product_unit) {
            product_new_item.unit_value = val.value;
          }
          // val.row_id = row_index;
          // row_index += 1;

        });
        product_new_item.name = this.product_name;
        product_new_item.unit = this.product_unit;
        product_new_item.count = this.product_count;
        product_new_item.price = this.product_price;
        product_new_item.summary = this.product_summary;
        product_new_item.product_id = this.selected_product;
        product_new_item.locationType = this.selected_target_location;
        product_new_item.location = this.product_district;
        this.product_items.push(product_new_item);
        this.product_name = "";
        this.product_unit = "";
        this.product_count = "";
        this.product_summary = '';
        this.product_price = 0;
        var row_index = 0;
        this.product_items.forEach((val) => {
          val.row_id = row_index;
          row_index += 1;

        });
      }
    },
    edit_item(item) {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.name = item.unitName;
      this.color = item.color;
      this.description = item.description;
      this.previewImage = item.image;
      this.status_form = item.id;
      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    },
    emptyList() {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      if (this.status_form != 0) {
        this.$router.push({path: '/dashboard/products/list'})
      } else {
        this.status_form = 0;
        this.name = '';
        this.color = '';
        this.description = '';
        this.previewImage = '';
        this.weight = '';
        this.selected_unit = '0';
        this.selected_brand = '0';
        this.selected_category = '0';
        this.barcode = '';
      }

      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    },

    get_places() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetPlaces', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          // self.items =  content_data.data.map((item, row_id) => { return {...item, row_id}}),
          //         fields;
          self.places_items = content_data.data;


        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }
      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_product_units() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetProductUnits', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          // self.items =  content_data.data.map((item, row_id) => { return {...item, row_id}}),
          //         fields;
          self.unit_items = content_data.data;


        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },

    insert_data_factor() {
      if (!this.validateForm()) {
        return true;
      }

      let self = this;
      const formData = new FormData();
      let url;

      if (this.status_form == 0) {
        url = "AddVisitorTargetMaster";
      } else {
        url = "EditVisitorTargetMaster";
        formData.append('Id', this.status_form)

      }


      formData.append('VisitorId', this.document_person);
      formData.append('Title', this.title_target);
      formData.append('TargetType', this.selected_target_type);
      formData.append('VisPercent', this.price_target);
      axios.post(url, formData, {}).then((res) => {

        // self.get_lists();
        self.$root.modal_component.show_api_response_modals(res);
        if (this.status_form == 0) {

          self.master_id = res.data.data.id;
          self.insert_factor_products();

          // self.product_items.forEach((val) => {
          //     self.insert_factor_products(index);
          //     index+=1;
          //
          // });

        } else {
          // this.$router.push({path:'/dashboard/products/list'})

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    insert_factor_products() {

      let self = this;
      const formData = new FormData();
      let url;
      // if (this.status_form == 0) {
      url = "AddVisitorTargetDetail";

      var sending_products = [];
      self.product_items.forEach((val) => {


      formData.append('MasterTargetId', self.master_id);
      formData.append('Qty', val.count);
      formData.append('ProductId', val.product_id);

      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);
        if (self.status_form == 0) {
          self.date = "";
          self.document_person = null;
          self.document_summary = "";
          // if (index == self.product_items.length - 1) {
          self.product_items = [];
          self.selected_place = 0;

          // }else {
          // this.$router.push({path:'/dashboard/products/list'})
          // self.insert_factor_products(index+1);

          // }
        }


      })
          .catch(function (error) {

            console.log(error);
          });

      });


    }

    , delete_item_dialog(item) {
      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], this.confirm_delete_name);

      this.status_form = item.row_id;

    },
    delete_item() {

      this.product_items.splice(this.status_form, 1);
      var row_index = 0;
      this.product_items.forEach((val) => {
        val.row_id = row_index;
        row_index += 1;

      });
      this.status_form = 0;

      // let self = this;
      // const formData = new FormData()
      // let url;
      // url = "DeleteBrand";
      //
      //
      // formData.append('id', this.status_form);
      //
      // axios.post(url, formData, {}).then((res) => {
      //
      //     this.$root.modal_component.show_api_response_modals(res);
      //
      //     self.status_form = 0;
      //
      //     // self.get_lists();
      //
      //
      // })
      //     .catch(function (error) {
      //         self.message = 'Incorrect E-mail or password';
      //         self.showMessage = true;
      //         console.log(error);
      //     });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
    get_document_master() {
      var self = this;
      console.log("route id " + this.$route.params.edit_doc_id);

      const formData = new FormData();

      var url = "GetRecById";

      formData.append("id", this.$route.params.edit_doc_id);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
//     self.items_buy = content_data.data.map((item, row_id) => {
// // if(item.isCustomer){
//     return {...item, row_id}
          self.selectedType = content_data.data.docType;
          self.document_person = content_data.data.partyName;
          self.date = content_data.data.docDate.replace("-", "/").replace("-", "/");
          self.selected_place = content_data.data.PlaceId;
          self.document_summary = content_data.data.docDesc;
          self.document_visitor = content_data.data.createdBy;
          self.document_driver = content_data.data.toziKonande;
          self.doc_status = content_data.data.statusId;
          self.tablo = content_data.data.tablo;
          self.address = content_data.data.addressText;
          self.vMobile = content_data.data.vMobile;
          self.partyMobile = content_data.data.partyMobile;
          self.tozikonandeMobile = content_data.data.tozikonandeMobile;

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }
      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_document_details() {
      var self = this;


      const formData = new FormData();

      var url = "GetDocItemsByDocId";

      formData.append("id", this.$route.params.edit_doc_id);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {


          content_data.data.forEach((val) => {
            self.add_edit_factor_product_to_document(val);
          });

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }
      })
          .catch(function (error) {

            console.log(error);
          });

    },
    add_edit_factor_product_to_document(item) {
      // ,,"productUnitId":1,"productUnitName":"کارتن 12 تایی","value":12,"qty":1,"price":"11960","docDesc":""
      var product_new_item = [];

      this.unit_items.forEach((val) => {
        if (val.id == item.productUnitId) {
          product_new_item.unit_value = val.value;
        }
        // val.row_id = row_index;
        // row_index += 1;

      });
      product_new_item.name = item.productName;
      product_new_item.unit = item.productUnitId;
      product_new_item.count = item.qty;
      product_new_item.price = item.price;
      product_new_item.summary = item.docDesc;
      product_new_item.product_id = item.productId;
      this.product_items.push(product_new_item);
      var row_index = 0;
      this.product_items.forEach((val) => {
        val.row_id = row_index;
        row_index += 1;

      });

    }
  }
}

</script>
